import { isSemesterId } from "./semesters";

export function courseScheduleHref(baseId: string, semester?: string): string {
  const query = new URLSearchParams({ add: baseId.replace(/\D/g, "") });
  if (isSemesterId(semester)) query.set("semester", semester);
  return `/scheduling?${query}`;
}

/** Keep public course intent through schedule selection and authentication. */
export function selectedScheduleHref(
  scheduleId: string,
  search: string,
): string {
  const source = new URLSearchParams(search);
  const query = new URLSearchParams({ id: scheduleId });
  const add = source.get("add") ?? "";
  if (/^(?:\d{8}|\d{2}:\d{3}:\d{3})$/.test(add))
    query.set("add", add.replace(/\D/g, ""));
  const semester = source.get("semester");
  if (isSemesterId(semester)) query.set("semester", semester);
  return `/scheduling?${query}`;
}
